import { ForwardedRef } from "react";
import Collapse from "../../collapse";
import { PropsWithAs } from "../../types";
import { forwardRefWithGeneric } from "../../utils";
import CardBody, { CardBodyProps } from "../cardBody";
import { useCardContext } from "./context";

const CollapsibleCardBody = <T extends React.ElementType = "div">(
  props: PropsWithAs<CardBodyProps, T> & { unmountOnClose?: boolean },
  ref: ForwardedRef<any>
) => {
  const { collapsed } = useCardContext();
  const { unmountOnClose } = props;
  return (
    <Collapse in={!collapsed} unmountOnClose={unmountOnClose}>
      <CardBody {...props} ref={ref} />
    </Collapse>
  );
};

export default forwardRefWithGeneric(CollapsibleCardBody);
